export default __webpack_public_path__ + "static/media/lolo.193fe72b.png";